import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import {blue, grey} from '@mui/material/colors'
import {CAward} from 'app/modules/discovery/core'
import {Link as RouterLink} from 'react-router-dom'
import {useTracking} from 'react-tracking'
import AwardDataBox from '../AwardDataBox'
import FavoriteButton from '../FavoriteButton'
import ShowMoreText from '../ShowMoreText'
import AwardIcon from '../icons/AwardIcon'

export default function AwardResultCard({
  award,
  currScrollPosition,
  search,
  fromDirectory,
  fromProject,
  page,
  pid,
  showFullAward,
}: {
  award: CAward
  currScrollPosition?: number
  search?: string
  fromDirectory?: boolean
  fromProject?: boolean
  page?: number
  pid?: string
  showFullAward?: (awdId: string) => void
}) {
  const {trackEvent} = useTracking<{entity: string; id: string}>()
  return (
    <Grid container mb={2}>
      <Grid item xs={12} sm={12} md={12} lg={10} display='flex' alignItems={'baseline'}>
        <Box
          sx={{
            display: 'flex',
            flex: '1 1 auto',
            justifyContent: 'space-between',
            justifyItems: 'center',
            fontSize: '22px',
            alignItems: 'center',
            fontWeight: '500',
          }}
          gap={1}
        >
          <Box
            sx={{
              flex: '1 1 auto',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                fontSize: '22px',
                alignItems: 'center',
                fontWeight: '500',
              }}
            >
              <Typography variant={'h5'} fontWeight={600}>
                {fromDirectory ? (
                  <RouterLink
                    to={`/awards/detail?awardId=${
                      award.id
                    }&scrollPosition=${currScrollPosition}&fromAwardDirectory=${
                      search !== '' ? search : 'tru'
                    }${page ? `&page=${page}` : ''}`}
                    onClick={() => {
                      trackEvent({entity: 'award', id: `${award.id}`})
                    }}
                  >
                    {award?.business_standard_business_name ?? ''}
                  </RouterLink>
                ) : fromProject && showFullAward ? (
                  <Box
                    onClick={() => award.id && showFullAward(award.id)}
                    style={{color: blue[300], cursor: 'pointer'}}
                  >
                    {award?.business_standard_business_name}
                  </Box>
                ) : pid ? (
                  <RouterLink
                    to={`/awards/detail?awardId=${award.id}&retval=/projects/detail?pid=${pid}+pTab=awards`}
                  >
                    {award?.business_standard_business_name ?? ''}
                  </RouterLink>
                ) : (
                  <RouterLink to={`/awards/detail?awardId=${award.id}`}>
                    {award?.business_standard_business_name ?? ''}
                  </RouterLink>
                )}
              </Typography>
            </Box>
            {/* Company */}
            <Box display={'flex'} flexDirection={'column'}>
              <Typography variant={'h6'} fontWeight={600} mb={1}>
                <Link href={award?.url ?? '#'} target='_blank' rel='noreferrer' color={grey[600]}>
                  <AwardIcon width='400' height='400' fs='medium' /> {award?.name}
                  <OpenInNewIcon fontSize={'small'} />
                </Link>
              </Typography>
              <AwardDataBox award={award} />
            </Box>

            <Box>
              <ShowMoreText
                variant={'h6'}
                maxLen={300}
                text={award?.abstract ?? ''}
                emptyCondition={'no description'}
                moreString='...Show More'
                lessString='...Show Less'
              />
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={1}>
        {' '}
      </Grid>
      <Grid item xs={1}>
        <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} gap={1}>
          <FavoriteButton item={award} type={'awards'} />
        </Box>
      </Grid>
    </Grid>
  )
}
